import { translate } from 'components/Translation';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import React, { useMemo, useState } from 'react';
import { BodyM } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesStyle';
import { makeStyles } from '@material-ui/core';
import DialogTermsAndConditions from 'views/Numbers/Details/Services/subcomponents/common/DialogTermsAndConditions';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import VatClause from 'components/VatClause/VatClause';
import MobileInternetPlansTable from 'components/ServicesTables/MobileInternetPlansTable';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';
import Note from '../../../../common/Note';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IActivateMobileInternetDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
	termsAndConditions: types.services.termsAndConditions;
	packages: SinglePackage[];
	enabledPackages: SinglePackage[];
	header: string;
	buttonText: string;
	additionalText: string;
	type: types.services.tableType;
	updateServices: types.services.updateServicesFunction;
}

const ActivateMobileInternetDialog = ({
	isOpen,
	hideDialog,
	termsAndConditions,
	packages,
	enabledPackages,
	header,
	buttonText,
	additionalText,
	type,
	updateServices,
}: IActivateMobileInternetDialogProps) => {
	const classes = useStyles();
	const [selectedTab, setSelectedTab] = useState<number | null>(null);
	const [isChecked, setIsChecked] = useState<boolean>(false);
	const [showError, setShowError] = useState<boolean>(false);

	const activationButtonDisabled = useMemo(() => {
		return selectedTab === null || selectedTab < 0 || (showError && !isChecked);
	}, [selectedTab, showError, isChecked]);

	const activate = () => {
		if (!isChecked) {
			setShowError(true);
		} else {
			setShowError(false);
			if (selectedTab !== null && selectedTab >= 0) {
				hideDialog();
				const singlePackage = packages[selectedTab];
				const orderItems: types.services.IOrderItem[] = [
					{
						action: 'ADD',
						id: singlePackage.partNumber,
						place: singlePackage.place,
						ebuConfigProduct: singlePackage.ebuConfigProduct,
					},
				];
				const actionType: types.services.actionType = type === 'TOP_UP' ? 'TOP_UP' : 'TURN_ON';
				updateServices(orderItems, singlePackage.name, actionType, true);
			}
		}
	};

	return (
		<CustomDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			width={1000}
			header={header}
			dialogBody={
				<div className={classes.gobizDialogBodyWrapper}>
					<div>
						<BodyM disableMargin>
							{translate(
								type === 'TOP_UP'
									? 'number.services.mobile.internet.select.top.up'
									: 'number.services.mobile.internet.select.plan'
							)}
						</BodyM>
					</div>
					<ConditionalRender show={!!additionalText} onTrue={() => <Note text={additionalText} />} />
					<MobileInternetPlansTable
						packages={packages}
						selectedTab={selectedTab}
						setSelectedTab={setSelectedTab}
						type={type}
						activePackages={enabledPackages}
					/>
					<VatClause type={'one-line'} />
					<div>
						<DialogTermsAndConditions
							termsAndConditions={termsAndConditions}
							isChecked={isChecked}
							setIsChecked={setIsChecked}
							showError={showError}
							showCheckbox
						/>
					</div>
				</div>
			}
			rightSideButtons={[
				{
					text: translate('cancel'),
					color: 'tertiary-light',
					onClick: hideDialog,
				},
				{
					text: buttonText,
					color: 'primary-light',
					disabled: activationButtonDisabled,
					onClick: activate,
				},
			]}
		/>
	);
};

export default ActivateMobileInternetDialog;
